export default __webpack_public_path__ + "static/media/ukrainegot-mobile-3.c2573c10.png";